/* Motion Molds: Shopify storefront JS */
/* Popup, gallery, review carousel, sticky bar, quantity control. The cart
   drawer lives in assets/mm-cart.js, loaded first, reached as window.MMCart. */

(function () {
  'use strict';

  const Cart = window.MMCart;

  // ──────────────────────────────────────────────
  // PRODUCT GALLERY (carousel with thumbs + lightbox)
  // ──────────────────────────────────────────────
  let lightboxState = null;
  const ensureLightbox = () => {
    if (document.getElementById('product-lightbox')) return;
    document.body.insertAdjacentHTML('beforeend',
      '<div class="product-lightbox" id="product-lightbox" role="dialog" aria-modal="true" aria-hidden="true">' +
        '<button class="product-lightbox-close" id="lightbox-close" aria-label="Close">×</button>' +
        '<button class="product-lightbox-nav product-lightbox-nav-prev" id="lightbox-prev" aria-label="Previous">←</button>' +
        '<button class="product-lightbox-nav product-lightbox-nav-next" id="lightbox-next" aria-label="Next">→</button>' +
        '<img class="product-lightbox-img" id="lightbox-img" alt="">' +
        '<div class="product-lightbox-counter" id="lightbox-counter"></div>' +
      '</div>'
    );
    const lb = document.getElementById('product-lightbox');
    document.getElementById('lightbox-close').addEventListener('click', closeLightbox);
    document.getElementById('lightbox-prev').addEventListener('click', (e) => { e.stopPropagation(); if (lightboxState) lightboxState.prev(); });
    document.getElementById('lightbox-next').addEventListener('click', (e) => { e.stopPropagation(); if (lightboxState) lightboxState.next(); });
    lb.addEventListener('click', (e) => { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', (e) => {
      if (!lightboxState) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') lightboxState.next();
      else if (e.key === 'ArrowLeft') lightboxState.prev();
    });
  };
  const openLightbox = (imgs, startIdx, syncParent) => {
    ensureLightbox();
    const lb = document.getElementById('product-lightbox');
    const lbImg = document.getElementById('lightbox-img');
    const lbCounter = document.getElementById('lightbox-counter');
    let idx = startIdx;
    const update = () => {
      lbImg.src = imgs[idx].src;
      lbImg.alt = imgs[idx].alt || '';
      lbCounter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(imgs.length).padStart(2, '0');
      syncParent(idx);
    };
    lightboxState = {
      next: () => { idx = (idx + 1) % imgs.length; update(); },
      prev: () => { idx = (idx - 1 + imgs.length) % imgs.length; update(); }
    };
    update();
    lb.classList.add('visible');
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeLightbox = () => {
    const lb = document.getElementById('product-lightbox');
    if (!lb) return;
    lb.classList.remove('visible');
    lb.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lightboxState = null;
  };
  const initProductGalleries = () => {
    document.querySelectorAll('.product-media').forEach(media => {
      const mainImgs = media.querySelectorAll('.product-media-main img');
      const thumbs = media.querySelectorAll('.product-media-thumb');
      if (mainImgs.length < 2 || thumbs.length < 2) return;
      const main = media.querySelector('.product-media-main');
      const counter = media.querySelector('.product-media-counter');
      const prevBtn = media.querySelector('.product-media-nav-prev');
      const nextBtn = media.querySelector('.product-media-nav-next');
      let activeIdx = 0;
      const pad = (n) => String(n).padStart(2, '0');
      const total = pad(mainImgs.length);
      const setActive = (i) => {
        activeIdx = ((i % mainImgs.length) + mainImgs.length) % mainImgs.length;
        mainImgs.forEach(img => img.classList.remove('active'));
        thumbs.forEach(t => t.classList.remove('active'));
        if (mainImgs[activeIdx]) mainImgs[activeIdx].classList.add('active');
        if (thumbs[activeIdx]) thumbs[activeIdx].classList.add('active');
        if (counter) counter.textContent = pad(activeIdx + 1) + ' / ' + total;
      };
      setActive(0);
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', (e) => { e.preventDefault(); setActive(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); setActive(activeIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); setActive(activeIdx + 1); });
      if (main) {
        main.addEventListener('click', (e) => {
          if (e.target.closest('.product-media-nav')) return;
          openLightbox(mainImgs, activeIdx, setActive);
        });
      }
    });
  };

  // ──────────────────────────────────────────────
  // REVIEW CAROUSELS
  // ──────────────────────────────────────────────
  const initReviewCarousels = () => {
    document.querySelectorAll('.reviews-grid').forEach(grid => {
      const cards = grid.querySelectorAll('.review-card');
      if (cards.length < 2) return;
      let timer;
      const pageCount = () => Math.max(1, Math.ceil(grid.scrollWidth / grid.clientWidth));
      const currentPage = () => Math.round(grid.scrollLeft / grid.clientWidth);
      const dots = document.createElement('div');
      dots.className = 'reviews-dots';
      const rebuildDots = () => {
        dots.innerHTML = '';
        const pages = pageCount();
        for (let i = 0; i < pages; i++) {
          const btn = document.createElement('button');
          btn.setAttribute('aria-label', 'Page ' + (i + 1));
          btn.addEventListener('click', () => { goToPage(i); restart(); });
          if (i === 0) btn.classList.add('active');
          dots.appendChild(btn);
        }
      };
      rebuildDots();
      grid.insertAdjacentElement('afterend', dots);
      const goToPage = (i) => { grid.scrollTo({ left: i * grid.clientWidth, behavior: 'smooth' }); };
      const advance = () => { goToPage((currentPage() + 1) % pageCount()); };
      const restart = () => { clearInterval(timer); timer = setInterval(advance, 15000); };
      grid.addEventListener('mouseenter', () => clearInterval(timer));
      grid.addEventListener('mouseleave', restart);
      grid.addEventListener('scroll', () => {
        const p = currentPage();
        Array.from(dots.children).forEach((d, i) => d.classList.toggle('active', i === p));
      }, { passive: true });
      window.addEventListener('resize', () => { rebuildDots(); });
      restart();
    });
  };

  // ──────────────────────────────────────────────
  // STICKY ADD-TO-CART
  // ──────────────────────────────────────────────
  const initStickyCart = () => {
    const stickyCart = document.getElementById('sticky-cart');
    const productInfo = document.querySelector('.product-info');
    if (!stickyCart || !productInfo) return;
    const onScroll = () => {
      const rect = productInfo.getBoundingClientRect();
      if (rect.bottom < 0) stickyCart.classList.add('visible');
      else stickyCart.classList.remove('visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  // ──────────────────────────────────────────────
  // NEWSLETTER POPUP
  // ──────────────────────────────────────────────
  const initPopup = () => {
    const KEY = 'mm_popup_dismissed';
    if (localStorage.getItem(KEY)) return;
    const overlay = document.getElementById('popup-overlay');
    if (!overlay) return;
    const close = () => {
      overlay.classList.remove('visible');
      overlay.setAttribute('aria-hidden', 'true');
      localStorage.setItem(KEY, '1');
    };
    document.getElementById('popup-close').addEventListener('click', close);
    const decline = document.getElementById('popup-decline');
    if (decline) decline.addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('visible')) close(); });
    const delay = parseInt(overlay.dataset.delay || '6', 10) * 1000;
    setTimeout(() => {
      overlay.classList.add('visible');
      overlay.setAttribute('aria-hidden', 'false');
    }, delay);
  };

  // ──────────────────────────────────────────────
  // QTY CONTROL (PDP)
  // ──────────────────────────────────────────────
  const initQty = () => {
    document.querySelectorAll('.qty-control').forEach(ctrl => {
      const input = ctrl.parentNode.querySelector('input[name="quantity"]') || ctrl.querySelector('span');
      const display = ctrl.querySelector('span');
      ctrl.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const delta = btn.dataset.delta === '-1' ? -1 : 1;
          const cur = parseInt(display.textContent, 10) || 1;
          const next = Math.max(1, cur + delta);
          display.textContent = next;
          if (input && input !== display) input.value = next;
        });
      });
    });
  };

  // ──────────────────────────────────────────────
  // INIT
  // ──────────────────────────────────────────────
  const init = async () => {
    if (Cart) {
      Cart.bind();
      try { await Cart.fetch(); Cart.render(); } catch (e) { /* ignore */ }
    }
    initProductGalleries();
    initReviewCarousels();
    initStickyCart();
    initPopup();
    initQty();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();